/*
  title: 메뉴명
  path: 경로
  icon: <아이콘 컴포넌트 />

  subMenuTitle: 서브메뉴 목록 명
  children: 서브메뉴 목록
*/

import i18n from 'locales/i18n'; // i18n 인스턴스 import
import {
  CalendarOutlineIcon,
  ChartBarOutlineIcon,
  ChartPieOutlineIcon,
  ChartSquareBarOutlineIcon,
  ChatAltOutlineIcon,
  ClipboardOutlineIcon,
  CollectionOutlineIcon,
  CreditCardOutlineIcon,
  DocumentReportOutlineIcon,
  DuplicateOutlineIcon,
  GroundstationIcon,
  QuestionMarkCircleOutlineIcon,
  SatelliteIcon,
  TagOutlineIcon,
  UserOutlineIcon,
  ViewGridOutlineIcon,
  HomeOutlineIcon,
  MailOutlineIcon,
  PencilAltOutlineIcon,
  CloudDownloadOutlineIcon,
  ClockIcon,
  ClockOutlineIcon
} from 'assets/svgs';

// 타입 정의
type IconComponentsType = {
  // eslint-disable-next-line no-undef
  [key: string]: JSX.Element;
};

const iconComponents = {
  CalendarOutlineIcon: <CalendarOutlineIcon />,
  ChartBarOutlineIcon: <ChartBarOutlineIcon />,
  ChartPieOutlineIcon: <ChartPieOutlineIcon />,
  ChartSquareBarOutlineIcon: <ChartSquareBarOutlineIcon />,
  ChatAltOutlineIcon: <ChatAltOutlineIcon />,
  ClipboardOutlineIcon: <ClipboardOutlineIcon />,
  CollectionOutlineIcon: <CollectionOutlineIcon />,
  CreditCardOutlineIcon: <CreditCardOutlineIcon />,
  DocumentReportOutlineIcon: <DocumentReportOutlineIcon />,
  DuplicateOutlineIcon: <DuplicateOutlineIcon />,
  GroundstationIcon: <GroundstationIcon />,
  QuestionMarkCircleOutlineIcon: <QuestionMarkCircleOutlineIcon />,
  SatelliteIcon: <SatelliteIcon />,
  TagOutlineIcon: <TagOutlineIcon />,
  UserOutlineIcon: <UserOutlineIcon />,
  ViewGridOutlineIcon: <ViewGridOutlineIcon />,
  HomeOutlineIcon: <HomeOutlineIcon />,
  MailOutlineIcon: <MailOutlineIcon />,
  PencilAltOutlineIcon: <PencilAltOutlineIcon />,
  ClockIcon:<ClockOutlineIcon/>,
  CloudDownloadOutlineIcon: <CloudDownloadOutlineIcon />
} as const;

type IconName = keyof typeof iconComponents;

// eslint-disable-next-line no-undef
export const getIconComponent = (iconName: string): JSX.Element | null => {
  if (iconName in iconComponents) {
    return iconComponents[iconName as IconName] || null;
  }
  return null;
};

// eslint-disable-next-line import/first
import { SidebarSubMenu } from 'types/sidebar';

const t = i18n.t; // t 함수 가져오기

export const sideBarMenuList: SidebarSubMenu[] = [
  {
    subMenuTitle: t('Home'),
    children: [
      {
        title: t('Dashboard'),
        path: '/dashboard',
        iconName: 'ChartSquareBarOutlineIcon',
        isHeaderHidden: true
      }
    ]
  },
  {
    subMenuTitle: t('Pricing'),
    children: [
      {
        title: t('Pricing'),
        path: '/pricing',
        iconName: 'CreditCardOutlineIcon'
      },
      {
        title: t('Calculator'),
        path: '/calculator',
        iconName: 'ChartPieOutlineIcon'
      },
      {
        title: t('Promotion'),
        path: '/promotion',
        iconName: 'TagOutlineIcon'
      }
    ]
  },
  {
    subMenuTitle: t('Schedule'),
    children: [
      { title: t('Get Started'), path: '/get-started', iconName: 'ViewGridOutlineIcon' },
      { title: t('Manage Spacecraft'), path: '/manage-spacecraft', iconName: 'SatelliteIcon', isHeaderHidden: true },
      { title: t('Contact Profile'), path: '/contact-profile', iconName: 'ClipboardOutlineIcon', isHeaderHidden: true },
      { title: t('Schedule a Contact'), path: '/schedule-contact', iconName: 'CalendarOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Contacts'), path: '/manage-contacts', iconName: 'ChartBarOutlineIcon', isHeaderHidden: true }
    ]
  },
    {
    subMenuTitle: t('Mission Control'),
    children: [
      { title: t('Commanding'), path: '/commanding', iconName: 'DocumentReportOutlineIcon', isHeaderHidden: true },
    ]
  },
  {
    subMenuTitle: t('Support'),
    children: [
      { title: t('FAQ'), path: '/faq', iconName: 'QuestionMarkCircleOutlineIcon' },
      { title: t('Contact Us'), path: '/contact-us', iconName: 'ChatAltOutlineIcon' },
      { title: t('SpaceTime Tools'), path: '/spacetime-tools', iconName: 'ClockIcon' }
    ]
  }
];
export const sideBarAdminMenuList: SidebarSubMenu[] = [
  ...sideBarMenuList,
  {
    subMenuTitle: t('Admin'),
    children: [
      { title: t('Manage User'), path: '/manage-user', iconName: 'UserOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Ground Station'), path: '/manage-ground-station', iconName: 'GroundstationIcon', isHeaderHidden: true },
      { title: t('Manage S3'), path: '/manage-s3', iconName: 'CloudDownloadOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Schedule'), path: '/manage-schedule', iconName: 'CalendarOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Payment'), path: '/manage-payment', iconName: 'CreditCardOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Mail'), path: '/manage-mail', iconName: 'MailOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Inquiry'), path: '/manage-inquiry', iconName: 'PencilAltOutlineIcon', isHeaderHidden: true },
      { title: t('Manage Promotion'), path: '/manage-promotion', iconName: 'TagOutlineIcon', isHeaderHidden: true }
    ],
    isAdmin: true
  }
];

export function getPathToTitleObj(): Record<string, { title: string; description?: string; isHeaderHidden?: boolean }> {
  const allMenus = [...sideBarMenuList, ...sideBarAdminMenuList];
  return allMenus.reduce(
    (acc, cur) => {
      cur.children.forEach((child) => {
        acc[child.path] = { title: child.title, description: child.description, isHeaderHidden: child.isHeaderHidden };
        return acc;
      });
      return acc;
    },
    {} as Record<string, { title: string; description?: string; isHeaderHidden?: boolean }>
  );
}